<atn-summit-pulse-section
  class="atn-summit-pulse-outcomes"
  name="Outcomes"
>
  TODO
</atn-summit-pulse-section>
